import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useLayoutEffect } from "react";
import { fontsSize, type FontsSizeTypes } from "components/A11yControls/helpers";
import useHighContrast from "utils/hooks/useHighContrast";
const hcClass = "dark";
const fontSize = "--font-size";
export function useA11ySettings() {
  const $ = _c(23);
  const params = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const [isHighContrast] = useHighContrast();
  let t0;
  if ($[0] !== params) {
    t0 = params.get("fs");
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fs = t0 as FontsSizeTypes;
  let t1;
  if ($[2] !== params) {
    t1 = params.get("hc");
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hc = t1;
  let t2;
  if ($[4] !== params || $[5] !== pathname || $[6] !== router) {
    t2 = (key, value) => {
      const newParams = new URLSearchParams(params.toString());
      newParams.set(key, value);
      router.replace(`${pathname}?${newParams.toString()}`);
    };
    $[4] = params;
    $[5] = pathname;
    $[6] = router;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const setParams = t2;
  let t3;
  if ($[8] !== setParams) {
    t3 = value_0 => {
      document.documentElement.style.setProperty(fontSize, fontsSize[value_0]);
      setParams("fs", value_0);
    };
    $[8] = setParams;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const setFontSize = t3;
  let t4;
  if ($[10] !== hc || $[11] !== setParams) {
    t4 = () => {
      document.documentElement.classList.toggle(hcClass);
      setParams("hc", hc === "1" ? "0" : "1");
    };
    $[10] = hc;
    $[11] = setParams;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const toggleHighContrast = t4;
  let t5;
  let t6;
  if ($[13] !== hc) {
    t5 = () => {
      if (hc === "1") {
        document.documentElement.classList.add(hcClass);
      }
      if (hc === "0") {
        document.documentElement.classList.remove(hcClass);
      }
    };
    t6 = [hc];
    $[13] = hc;
    $[14] = t5;
    $[15] = t6;
  } else {
    t5 = $[14];
    t6 = $[15];
  }
  useLayoutEffect(t5, t6);
  let t7;
  let t8;
  if ($[16] !== fs) {
    t7 = () => {
      if (fontsSize[fs]) {
        document.documentElement.style.setProperty(fontSize, fontsSize[fs]);
      }
    };
    t8 = [fs];
    $[16] = fs;
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  useLayoutEffect(t7, t8);
  let t9;
  if ($[19] !== isHighContrast || $[20] !== setFontSize || $[21] !== toggleHighContrast) {
    t9 = {
      setFontSize,
      toggleHighContrast,
      isHighContrast
    };
    $[19] = isHighContrast;
    $[20] = setFontSize;
    $[21] = toggleHighContrast;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}